import React from 'react';
import PropTypes from 'prop-types';
import { FolderSection, LabelValue } from '../Elements';
import { t } from '../../common/Translate';
import { useMarket } from '../../../hooks/useCalendar/useRecordBlocs/useMarket';

export const MarketBloc = ({ recordId }) => {
  const { isLoading, goToMarket, active, labels } = useMarket(recordId);

  return (
    <FolderSection
      title={t('market_analysis')}
      dataTestid="market-bloc"
      action={goToMarket}
      isLoading={isLoading}
      error={false}
      showArrow={active}
    >
      {active && (
        <>
          {labels.map(({ label, value }) => (
            <LabelValue label={label} value={value} key={label} />
          ))}
        </>
      )}
    </FolderSection>
  );
};

MarketBloc.propTypes = {
  recordId: PropTypes.number.isRequired,
};
